import axios from "axios";
import { auth } from "@/plugins/firebase";

const baseUrl = "https://api.destpay.com/";
const apiKey = "3ad103bc12f645a3a889f5d6355e1ad9";

export default {
    setFinancierId({ commit }, financierEmail) {
        axios
            .post(baseUrl + "financier", {
                financierEmail,
                apiKey
            })
            .then(response => {
                if (response.data && response.data.id) {
                    commit("SET_FINANCIER_ID", response.data.id);
                }

            })
            .catch((err) => console.log(err));
    },
    loadFinanciers({ commit }) {
        axios
            .get(baseUrl + "allFinanciers/" + apiKey)
            .then((response) => {
                commit("LOAD_FINANCIERS", response.data);
            })
            .catch((err) => console.log(err));
    },

    deleteFinancier({ commit, dispatch }, financierId) {
        axios
            .post(baseUrl + "deleteFinancier", {
                _id: financierId,
                apiKey
            })
            .then(() => {
                commit("DELETE_FINANCIER", financierId);
                dispatch("common/setSuccess", "Bayii Başarıyla Silindi!", { root: true });
            })
            .catch((err) => {
                console.log(err);
                dispatch("common/setError", "Bayii Silerken bir hata meydana geldi, lütfen daha sonra tekrar deneyiniz.!", { root: true });
            });
    },

    addFinancier({ commit, dispatch }, newFinancier) {
        axios
            .post(baseUrl + "addFinancier", {
                apiKey,
                ...newFinancier
            })
            .then(() => {
                auth.createUserWithEmailAndPassword(newFinancier.firmaEmail, newFinancier.firmaSifre)
                    .then((userCredential) => {
                        console.log(userCredential);
                        commit("ADD_FINANCIER", newFinancier);
                        dispatch("common/setSuccess", "Bayii Başarıyla EKlendi!", { root: true });
                    })
                    .catch((error) => {
                        console.log(error);
                        dispatch("common/setError", "Bayii EKlerken bir hata meydana geldi, lütfen daha sonra tekrar deneyiniz.!", { root: true });
                    });
            })
            .catch((err) => {
                console.log(err);
                dispatch("common/setError", "Bayii EKlerken bir hata meydana geldi, lütfen daha sonra tekrar deneyiniz.!", { root: true });
            });
    },

    updateFinancier({ commit, dispatch }, newFinancier) {
        axios
            .post(baseUrl + "updateFinancier", {
                apiKey,
                ...newFinancier
            })
            .then(() => {
                commit("UPDATE_FINANCIER", newFinancier);
                dispatch("common/setSuccess", "Bayii Başarıyla Güncellendi!", { root: true });
            })
            .catch((err) => {
                console.log(err);
                dispatch("common/setError", "Bayii Güncellerken bir hata meydana geldi, lütfen daha sonra tekrar deneyiniz.!", { root: true });
            });
    }
};
